import axios from 'axios'

export const getMarketsByLocation = async (location, distance, size, token) => {
  const url = process.env.GATSBY_API_MARKET_SEARCH
  const headers = { Authorization: `Bearer ${token}` }
  const params = {
    op: 'byGeo',
    location: JSON.stringify(location),
    distance,
    size
  }

  const res = await axios({
    method: 'get',
    url,
    headers,
    params
  })

  const items = res.data.hits.hits.map(hit => hit._source)

  return {
    response: res,
    numberOfItems: res.data.hits.hits.length,
    result: items
  }
}
